const MESES =
  'enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|setiembre|octubre|noviembre|diciembre|ene|feb|mar|abr|may|jun|jul|ago|sept|sep|oct|nov|dic'

function escapeHtml (texto) {
  return String(texto || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function esFechaNumericaValida (d, m, y) {
  if (m < 1 || m > 12 || d < 1 || d > 31) return false
  if (y < 100) y += 2000
  if (y < 1990 || y > 2100) return false
  const fecha = new Date(y, m - 1, d)
  return fecha.getFullYear() === y && fecha.getMonth() === m - 1 && fecha.getDate() === d
}

function agregarRango (rangos, inicio, fin) {
  if (inicio < 0 || fin <= inicio) return
  rangos.push({ inicio, fin })
}

function agregarCoincidencias (texto, regex, rangos, validar) {
  const re = new RegExp(regex, 'gi')
  let coincidencia

  while ((coincidencia = re.exec(texto)) !== null) {
    const grupo = coincidencia[1] != null ? 1 : 0
    const fragmento = coincidencia[grupo]
    const inicio = coincidencia.index + coincidencia[0].indexOf(fragmento)
    const fin = inicio + fragmento.length

    if (!validar || validar(fragmento, coincidencia, inicio)) {
      agregarRango(rangos, inicio, fin)
    }
  }
}

function fusionarRangos (rangos) {
  if (!rangos.length) return []

  const ordenados = rangos.slice().sort((a, b) => a.inicio - b.inicio)
  const fusionados = [ordenados[0]]

  for (let i = 1; i < ordenados.length; i++) {
    const ultimo = fusionados[fusionados.length - 1]
    const actual = ordenados[i]

    if (actual.inicio <= ultimo.fin) {
      ultimo.fin = Math.max(ultimo.fin, actual.fin)
    } else {
      fusionados.push(actual)
    }
  }

  return fusionados
}

function validarFechaEspaciada (fragmento) {
  const partes = fragmento.trim().split(/\s+/)
  if (partes.length !== 3) return false

  const nums = partes.map((p) => parseInt(p, 10))
  if (nums.some((n) => Number.isNaN(n))) return false

  if (partes[2].length === 4) {
    return esFechaNumericaValida(nums[0], nums[1], nums[2])
  }

  if (partes[0].length === 2 && partes[1].length === 2 && partes[2].length === 2) {
    return esFechaNumericaValida(nums[1], nums[0], nums[2])
  }

  return false
}

function validarFechaSeparada (fragmento) {
  const partes = fragmento.split(/[\/\-\.]/)
  if (partes.length !== 3) return false

  const nums = partes.map((p) => parseInt(p, 10))
  if (nums.some((n) => Number.isNaN(n))) return false

  const [d, m, y] = nums
  return esFechaNumericaValida(d, m, y)
}

// Valida formatos con separadores o espacios mezclados (ej. "Fecha 25 06 2026")
function validarFechaFlexible (fragmento) {
  const partes = fragmento.split(/[\s\/\-\.]+/).filter(Boolean)
  if (partes.length !== 3) return false

  const nums = partes.map((p) => parseInt(p, 10))
  if (nums.some((n) => Number.isNaN(n))) return false

  const [d, m, y] = nums
  return esFechaNumericaValida(d, m, y)
}

// Valida día (1-31) en fechas con mes en texto (ej. "26JUN26", "25 junio 2026")
function validarDiaMesTexto (fragmento) {
  const dia = parseInt((fragmento.match(/^\d{1,2}/) || [])[0], 10)
  return dia >= 1 && dia <= 31
}

// Evita resaltar números espaciados que en realidad son una HORA (ej. "HORA 08 08 89")
function precedidoPorHora (texto, inicio) {
  const previo = texto.slice(Math.max(0, inicio - 10), inicio)
  return /hora[:\s]*$/i.test(previo)
}

export function resaltarFechasEnTexto (texto) {
  if (!texto) return ''

  const str = String(texto)

  // Prioridad alta: fechas inequívocas (mes en texto, palabra "Fecha", o separadores)
  const altaPrioridad = []
  // Prioridad baja: números espaciados ambiguos (solo si no hay nada mejor)
  const bajaPrioridad = []

  // 1) Día + mes en texto + año, con o sin espacios (ej. "25 junio 2026", "26JUN26")
  agregarCoincidencias(
    str,
    `(?<![A-Za-z0-9])(\\d{1,2}\\s*(?:${MESES})\\.?\\s*\\d{2,4})(?![A-Za-z0-9])`,
    altaPrioridad,
    (fragmento) => validarDiaMesTexto(fragmento)
  )

  // 2) Después de la palabra "Fecha", con espacios o separadores
  agregarCoincidencias(
    str,
    `Fecha[:\\s]+(\\d{1,2}[\\s\\/\\-\\.]\\d{1,2}[\\s\\/\\-\\.]\\d{2,4})`,
    altaPrioridad,
    (fragmento) => validarFechaFlexible(fragmento)
  )

  // 3) Separadores con año de 4 dígitos (ej. 25/06/2026)
  agregarCoincidencias(
    str,
    `(?<!\\d)(\\d{1,2}[\\/\\-\\.]\\d{1,2}[\\/\\-\\.]\\d{4})(?!\\d)`,
    altaPrioridad,
    (fragmento) => validarFechaSeparada(fragmento)
  )

  // 4) Separadores con año de 2 dígitos (ej. 25-06-26)
  agregarCoincidencias(
    str,
    `(?<!\\d)(\\d{1,2}[\\/\\-\\.]\\d{1,2}[\\/\\-\\.]\\d{2})(?!\\d)`,
    altaPrioridad,
    (fragmento) => validarFechaSeparada(fragmento)
  )

  // 5) (Baja) Números espaciados con año 20xx (ej. "25 06 2026" suelto)
  agregarCoincidencias(
    str,
    `(?<!\\d)(\\d{1,2}\\s+\\d{1,2}\\s+20\\d{2})(?!\\d)`,
    bajaPrioridad,
    (fragmento, _m, inicio) => validarFechaEspaciada(fragmento) && !precedidoPorHora(str, inicio)
  )

  // 6) (Baja) Tres pares de dígitos espaciados (ej. "06 25 26")
  agregarCoincidencias(
    str,
    `(?<!\\d)(\\d{2}\\s+\\d{2}\\s+\\d{2})(?!\\d)`,
    bajaPrioridad,
    (fragmento, _m, inicio) => validarFechaEspaciada(fragmento) && !precedidoPorHora(str, inicio)
  )

  const rangos = altaPrioridad.length ? altaPrioridad : bajaPrioridad
  const fusionados = fusionarRangos(rangos)

  let html = ''
  let posicion = 0

  for (const { inicio, fin } of fusionados) {
    html += escapeHtml(str.slice(posicion, inicio))
    html += `<mark class="fecha-resaltada">${escapeHtml(str.slice(inicio, fin))}</mark>`
    posicion = fin
  }

  html += escapeHtml(str.slice(posicion))
  return html
}
